export default "__VITE_ASSET__BYW$2$g6__"